import { ScheduleDisableReason } from '@classpass/protobuf-definitions/lib/node/models/inventory/v1/schedule_configuration';
import { VenueFcf } from '@classpass/protobuf-definitions/lib/web/models/inventory/venue_config';

// the id of the root element that will contain the rendered React app
export const APP_ROOT_ELEMENT_ID = 'react-body';

export const SORT_DIRECTION_ARROW_DIRECTION_MAP = {
  asc: 'up',
  dsc: 'down',
};

// Studio/Class Detail pages
export const PASSWORD_UPDATE_FORM_NAME = 'passwordUpdateForm';
export const CHANGE_LANGUAGE_FORM_NAME = 'changeLanguageForm';
export const DYNAMIC_PRICING_CONTROLS_FORM_NAME = 'dynamicPricingControlsForm';

// for max character counts on text update fields
export const LONG_TEXT_MAX_CHARACTERS = 2000;
export const MEDIUM_TEXT_MAX_CHARACTERS = 1200;
export const MEDIUM_SMALL_TEXT_MAX_CHARACTERS = 300;
export const SMALL_TEXT_MAX_CHARACTERS = 255;
export const MICRO_TEXT_MAX_CHARACTERS = 100;

// google calendar
export const GCAL_HOST = 'https://www.google.com/calendar/render';
export const GCAL_DATE_FORMAT = "yyyyMMdd'T'HHmmss";

export const HOME_CATEGORY = {
  SHARE: 'Share',
};

export const HOME_CATEGORY_TYPE = {
  RECOMMENDATIONS: 'HOME_CATEGORY_TYPE_RECOMMENDATIONS',
  OPPORTUNITIES: 'HOME_CATEGORY_TYPE_OPPORTUNITIES',
  SOCIAL: 'HOME_CATEGORY_TYPE_SOCIAL',
  USER_INSIGHTS: 'HOME_CATEGORY_TYPE_USER_INSIGHTS',
};

export const SUPPORTED_HOME_CARDS = {
  STUDIO_HOME_CARD_OPPORTUNITIES: 'studio_home_card_opportunities',
  STUDIO_HOME_CARD_SOCIAL: 'studio_home_card_social',
  STUDIO_HOME_CARD_USER_INSIGHTS: 'studio_home_card_user_insights',
};

export const PERMISSION = {
  CAN_CANCEL_ALL_FUTURE: 'can_cancel_all_future',
  CAN_MANAGE_PREMIUM_CAPS: 'can_manage_premium_caps',
  CAN_MANAGE_SMARTSPOT_VERSION: 'can_manage_smartspot_version',
  CAN_MANAGE_SMARTSPOT: 'can_manage_smartspot',
  CAN_SCHEDULE_SMARTSPOT_OFF: 'can_schedule_smartspot_off',
  CAN_SCHEDULE_SMARTSPOT_OFF_NR: 'can_schedule_smartspot_off_nr',
  CAN_MIGRATE_TO_FRONTDESK: 'can_migrate_to_frontdesk',
  CAN_VIEW_DYNAMIC_PRICING: 'can_view_dynamic_pricing',
  DISPLAY_RATE: 'display_rate',
  DISPLAY_SPOT_MANAGEMENT: 'display_spot_management',
  FEATURE_CLASSES_OVERRIDE: 'feature_classes_override',
  FEATURE_CLASSTIVITY_SCHEDULER: 'feature_classtivity_scheduler',
  FEATURE_DISABLE_INVENTORY: 'feature_disable_inventory',
  FEATURE_LIVESTREAM: 'feature_livestream',
  FEATURE_MARKET_INSIGHTS: 'feature_market_insights',
  FEATURE_PREMIUM: 'feature_premium',
  FEATURE_RATINGS_REVIEWS: 'feature_ratings_reviews',
  FEATURE_REPORTS_RESERVATIONS_TAB: 'feature_reports_reservations_tab',
  FEATURE_WAIVERS: 'feature_waivers',
  HIDE_FCF_SETTINGS: 'hide_fcf_settings',
  PREMIUM_CAPS_CAN_VIEW: 'premium_caps_can_view',
  REMOVE_CLASS_CANCEL: 'remove_class_cancel',
};

export const VENUE_SOURCE = {
  AIMHARDER: 'AIMHARDER',
  ANOTHERSPACE: 'ANOTHERSPACE',
  BEAT81: 'BEAT81',
  BEWE: 'BEWE',
  BIORITMO: 'BIORITMO',
  BLOSSOM: 'BLOSSOM',
  BOOKER: 'BOOKER',
  BSPORT: 'BSPORT',
  CLASSTIVITY: 'CLASSTIVITY',
  CLUBREADY: 'CLUBREADY',
  CONTROLPLUS: 'CONTROLPLUS',
  COWFACE: 'COWFACE',
  CRUNCH: 'CRUNCH',
  CUREFIT: 'CUREFIT',
  DIBS: 'DIBS',
  DIGME: 'DIGME',
  EVERSPORTS: 'EVERSPORTS',
  EVO: 'EVO',
  FITDEGREE: 'FITDEGREE',
  FITREPUBLIK: 'FITREPUBLIK',
  FLYWHEEL: 'FLYWHEEL',
  FRONTDESK: 'FRONTDESK',
  GLOFOX: 'GLOFOX',
  GOOGLE: 'GOOGLE',
  INFINITO: 'INFINITO',
  LIVEADDRESS: 'LIVEADDRESS',
  MAGICLINE: 'MAGICLINE',
  MANUAL_SKU: 'MANUAL_SKU',
  MARIANATEK: 'MARIANATEK',
  MINDBODY: 'MINDBODY',
  MINDBODYAPI: 'MINDBODYAPI',
  MINDBODYMANUAL: 'MINDBODYMANUAL',
  MSINVENTORY: 'MSINVENTORY',
  ONEFITSTOP: 'ONEFITSTOP',
  PUREPILATES: 'PUREPILATES',
  REZEVE: 'REZEVE',
  RIDEREPUBLIC: 'RIDEREPUBLIC',
  RITUAL: 'RITUAL',
  SPORTSOLUTION: 'SPORTSOLUTION',
  SQUARE: 'SQUARE',
  SQUARE_PRODUCT: 'SQUARE_PRODUCT',
  STUDIOREPUBLIK: 'STUDIOREPUBLIK',
  TEAMUP: 'TEAMUP',
  TECNOFIT: 'TECNOFIT',
  THEASSEMBLY: 'THEASSEMBLY',
  TIMP: 'TIMP',
  TONEHOUSE: 'TONEHOUSE',
  VIRTUAGYM: 'VIRTUAGYM',
  WELLNESSLIVING: 'WELLNESSLIVING',
  YOGAIA: 'YOGAIA',
  YOGAMOVEMENT: 'YOGAMOVEMENT',
  ZINGFIT: 'ZINGFIT',
};

export const MSI_SOURCES = [VENUE_SOURCE.MINDBODYMANUAL, VENUE_SOURCE.MSINVENTORY];

export const MANUAL_SKU_SOURCES = [VENUE_SOURCE.MANUAL_SKU];

// The makeEntityScaffold module in classpass-saga-tools will define an array of
// action creators and corresponding action types and add them to the entity scaffold
// These constants expose the implicit order that the types are defined in to enable
// meaningfully readable array access
export const REQUEST_TYPE_INDEX = 0; // REQUEST referred to as LOAD in the type constant
export const SUCCESS_TYPE_INDEX = 1;
export const ERROR_TYPE_INDEX = 2;

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export const SERVER_TIME_FORMAT = 'HH:mm:ss'; // ISO 8601

export const CLASS_CANCELLED_SCHEDULE_DISABLED_REASON = [
  ScheduleDisableReason.SCHEDULE_DISABLE_REASON_CLASS_CANCELLED,
  ScheduleDisableReason.SCHEDULE_DISABLE_REASON_DASHBOARD_CANCELLED,
  ScheduleDisableReason.SCHEDULE_DISABLE_REASON_INTEGRATION_CANCELLED,
];

export const CLASS_ENTITY_TYPE = {
  APPOINTMENT: 'APPOINTMENT',
  CLASS: 'CLASS',
};

export const CLASS_DISABLED_REASON = {
  INVALID_PRICING_OPTION: 'invalid_pricing_option',
  CLASS_NO_CAPACITY: 'class_no_capacity',
  CLASS_NOT_FOUND: 'class_not_found',
  CLASS_SOFT_DELETED: 'class_soft_deleted',
};

export const SMARTSPOT_REASON = {
  VENUE_SETTING: 'venue_setting',
  SCHEDULE_SETTING: 'schedule_setting',
  RECURRING_RULE: 'recurring_rule',
  GENERIC_UPDATE: 'generic_update',
};

export const SMARTSPOT_MODE = {
  AGGRESSIVE: 'aggressive',
  CLASSIC: 'classic',
};

export const PREMIUM_CAP_ENTITY = {
  VENUE: 'VENUE',
  CLASS: 'CLASS',
  SCHEDULE: 'SCHEDULE',
};

export const PREMIUM_CAP_RULE = {
  VENUE_DEFAULT: 'VENUE_DEFAULT',
  VENUE: 'VENUE',
  RECURRING_SCHEDULE: 'RECURRING_SCHEDULE',
  CLASS: 'CLASS',
  SCHEDULE: 'SCHEDULE',
};

export const NETWORK_CAP_RECURRENCE = {
  THIS_INSTANCE: 'instance',
  ALL_FUTURE_INSTANCES: 'all_future',
};

export const ENABLE_RECURRENCE = {
  SCHEDULE_LEVEL: 'instance',
  CLASS_LEVEL: 'instance_plus_future',
};

export const HOVERABLE_TOOLTIP_TIMES = 250;

export const EMAIL_REGEX = RegExp(
  /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
);

export const STAFF_REGEX = /^((?!staff).)*$/i; // any word that does not contain "staff"

export const PHONE_REGEX = /^\+?(\d{1,3})?[-.\s]?(\(?\d{3}\)?[-.\s]?)?(\d[-.\s]?){6,9}\d$/; // allow for common phone number formats

/* eslint-disable no-useless-escape */
export const URL_REGEX =
  /^(https?):\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/; // https://uibakery.io/regex-library/url
export const URL_PROTOCOL_REGEX = /^(https?)\:\/\//; // a subset of ⬆ for better error messages
export const URL_SIMPLE_REGEX =
  /^((https?):\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/; // https://uibakery.io/regex-library/url
export const FACEBOOK_REGEX = /facebook\.com/i; // contains the string "facebook.com" - hostnames are not case-sensitive, paths are
export const TWITTER_REGEX = /^[\w]{1,20}$/; // 20 or fewer characters, includes only alphanumeric characters and '_'
export const INSTAGRAM_REGEX = /^[\w.-]{1,32}$/; // 32 or fewer characters, includes only alphanumeric characters and special characters '_' '.' '-'
/* eslint-enable no-useless-escape */

export const DISMISSED_SMART_SPOT_BANNER_VENUE_IDS_LOCAL_STORAGE_KEY = 'dismissedSSBannerVenueIds';

export const USER_ROLE = {
  FRONT_DESK: 'front_desk',
  MANAGER: 'manager',
  OWNER: 'owner',
};

export const EMAIL_TYPES = {
  CANCEL: 'CANCEL',
  GENERIC: 'GENERIC',
  GENERIC_TO_NEW_USERS: 'GENERIC_TO_NEW_USERS',
  GENERIC_TO_SOME_USERS: 'GENERIC_TO_SOME_USERS',
};

export const FULL_ISO_DATE_FORMAT = `yyyy-MM-dd'T'HH:mm:ss`;

export const MANAGE_SERVICES_TAB = {
  RESOURCES: 'resources',
  PRACTITIONERS: 'practitioners',
  SERVICES: 'services',
};

export const VENUE_SERVICE_TYPES = {
  APPOINTMENT: 'APPOINTMENT',
  CLASS: 'CLASS',
  SKU: 'SKU',
};

export const BLOCK_OFF_TIME_ITEM_TYPES = {
  PRACTITIONER: 'practitioner',
  RESOURCE: 'resource',
  VENUE: 'venue',
};

export const CP_EMAIL_REGEX = RegExp(/^[A-Za-z0-9._%+-]+@(classpass|mindbodyonline|playlist).com$/i);

export const INVENTORY_ENTITY_TYPE = {
  TEACHER: 'TEACHER',
};

export const NEW_SERVICE_BANNER_LOCAL_STORAGE_KEY = 'showServicePostLaunchBanner';

export const MESSAGE_USER_ENTITY_TYPES = {
  GET: 'GET',
  POST: 'POST',
};

export const ATTENDANCE_INQUIRY_RESPONSE_DEADLINE_HOURS = 72;
export const FEEDBACK_REPORT_AGE_LIMIT_DAYS = 30;

// Countries where menu prices are displayed excluding tax (e.g. "not including tax").
// All other countries show tax-inclusive pricing. No backend equivalent exists — this
// is a frontend-only business rule. If this list grows, consider moving to a backend config.
export const TAX_EXCLUDED_MENU_PRICE_COUNTRIES = ['US', 'CA'];
export const getIsTaxExcludedMenuPrice = countryCodeShort =>
  TAX_EXCLUDED_MENU_PRICE_COUNTRIES.includes(countryCodeShort);

export const FCF_MODE = {
  [VenueFcf.VENUE_FCF_UNSPECIFIED]: 'UNSPECIFIED',
  [VenueFcf.VENUE_CONFIG_NONE]: 'NONE',
  [VenueFcf.ONE_PER_VENUE]: 'ONE_PER_VENUE',
  [VenueFcf.ONE_PER_ORG]: 'ONE_PER_ORG',
};
